import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import { homePageSchema } from "@/seo/schema";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import WhatWeDo from "./components/WhatWeDo";
import Platforms from "./components/Platforms";
import Training from "./components/Training";
import Innovation from "./components/Innovation";
import Events from "./components/Events";
import Legacy from "./components/Legacy";
import Partners from "./components/Partners";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={homePageSchema} />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <WhatWeDo />
        <Platforms />
        <Training />
        <Innovation />
        <Events />
        <Legacy />
        <Partners />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}